import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * An address from before the Settings area and the Customers rename: the same
 * place, where it lives now. Whatever followed the old address — an account's
 * id, the list's filters, a fragment — follows it to the new one, so a saved
 * link opens what it always opened.
 */
export function Moved({ to }: { to: string }) {
    const { slug = '', '*': rest = '' } = useParams();
    const { search, hash } = useLocation();
    return <Navigate to={`/w/${slug}/${to}${rest ? `/${rest}` : ''}${search}${hash}`} replace />;
}
